module.exports = __webpack_public_path__ + "img/logo-indigo.8f3e914c.svg";